import React from "react";
import "../App.css";
import { BaseAddress } from "../projConst";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ReportIcon from "@material-ui/icons/Report";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { width } from "@material-ui/system";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import * as api from '../api/apiFunc' 
import FormaterDate from '../Components/Formaters/FormaterDate';
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#343433',
    color: theme.palette.common.white,
    opacity: 0.7,
    maxHeight: '2vh',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);


const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 250,
        maxWidth: 350,
    maxHeight: 200,
    
        
    },    
    ShowTotal: {
        width: '100%',
        backgroundColor: '#fff',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif !important',
       // maxWidth: '60vw !important',
        //maxHeight: '35vh !important',
        //overflow: 'auto'
    },
    ShowTotalTitle: {
        backgroundColor: '#fff',
        padding: '10px '
  },
    ShowTotalTitle2: {
      backgroundColor: '#fff',
      padding: '10px',
      paddingTop: '0px'
  },
    ShowTotalTable: {
        backgroundColor: '#fff',
        marginLeft: '5px',
        //maxHeight: '50vh !important'
    }
}));

const ShowTable = ({data,title,title2,title3}) => {
  const classes = useStyles();
  
  const SvgCircle = ({ fill }) => (
    <span className='svg-circle'>  
     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
       <circle cx="10" cy="10" r="9" fill={fill} stroke="#828282" strokeWidth="1"/>
      </svg></span>)
  
  const SumGoods = () => {
    let tmpArray = []
    //data.filter((item) => {
    //  if (tmpArray.indexOf(item.kodgruza) === -1) {
    //  tmpArray.push(item.kodgruza);
    //  return true
  //}
    //  return false;
    //})

    const result = Object.values(data.reduce((r, e) => {
			let k = `${e.kodgruza}|${e.nazvgruza}`;
			if(!r[k]) r[k] = {...e, count: 1}
				else r[k].count ++;
			return r;
		}, {}))

    return (
      <>
        {api.isNotEmptyArr(result) && <div style={{padding: '10px'}}>
        <div style={{ fontWeight: 'bold', fontSize: '14px' }}>Итоги по грузам: </div>
        <div className="total-goods">
          {result.map((row) => {
            return (
              <div key={row.ID}>
                <span style={{paddingRight: '10px',paddingLeft: '10px'}}><SvgCircle fill={row.kodhex} /></span>
                {`${row.nazvgruza} (${row.kodgruza}) - ${row.count};`}
              </div>
            );
          })}
          </div>
         </div>
        }
      </>
    );
  }
  return (
    <div className={classes.ShowTotal}>
      
        <div className={classes.ShowTotalTitle} style={{borderBottom: '1px solid #343433'}}>
              {`${title} (${title2}) ${title3}`}
      </div>
      <Paper style={{ maxWidth: '60vw',maxHeight: '30vh', overflow: 'auto', margin: 10 }}>         
            <TableContainer>
              <Table className={classes.table} aria-label="customized table" >
                {!api.isNotEmptyArr(data) && <StyledTableRow>Нет Вагонов</StyledTableRow>}
                {api.isNotEmptyArr(data) && <>
                <TableHead style={{position: 'sticky', top: 0}}>
                <TableRow>
                  <StyledTableCell>Напр.</StyledTableCell>
                  <StyledTableCell align="center">Маркер</StyledTableCell>
                    <StyledTableCell align="center">№ вагона</StyledTableCell>
                    <StyledTableCell align="center">Наименование груза</StyledTableCell>
                    <StyledTableCell align="center">Код груза</StyledTableCell>
                    <StyledTableCell align="center">Отправитель</StyledTableCell>
                    <StyledTableCell align="center">Получатель</StyledTableCell>
                    <StyledTableCell align="center">Дорога</StyledTableCell>
                    <StyledTableCell align="center">Операция</StyledTableCell>
                    <StyledTableCell align="center">Дата операции</StyledTableCell>
                </TableRow>
                </TableHead>
              <TableBody>
                  {data.map((row) => {
                        return (
                            <StyledTableRow key={row.ID}>
                            {/*<StyledTableCell align="center" component="th" scope="row" title={row.napr == 1 ? 'Входящие' : 'Исходящие'}>{row.napr == 1 ? <img style={{ marginTop: 0 }} src={'static/img/in.png'} width='40%' height='30%' />
                              : <img style={{ marginTop: 0 }} src={'static/img/out.png'} width='70%' height='30%' />}</StyledTableCell>*/}
                                <StyledTableCell align="center" style={{ fontWeight: 'bold', fontSize: '16pt' }}>{row.napr == 1 ? '↓В' : '↑И'}</StyledTableCell>
                                <StyledTableCell align="center" ><SvgCircle fill={row.kodhex}/></StyledTableCell>
                                <StyledTableCell align="left">{row.nomv}</StyledTableCell>
                                <StyledTableCell align="left">{row.nazvgruza}</StyledTableCell>
                                <StyledTableCell align="left">{row.kodgruza}</StyledTableCell>
                                <StyledTableCell align="left">{row.nazvotpr}</StyledTableCell>
                                <StyledTableCell align="left">{row.nazvpol}</StyledTableCell>
                                <StyledTableCell align="left">{row.dor}</StyledTableCell>
                                <StyledTableCell align="left">{row.oper}</StyledTableCell>
                                <StyledTableCell align="left">{<FormaterDate value={row.datop} Time={true} Align={'left'} Color='black' FontSize='90%' />}</StyledTableCell>
                            </StyledTableRow>
                        )
                    }
                )}
                
                </TableBody> </>}
             </Table>
        </TableContainer> 
        
      </Paper>
      {SumGoods()}
      </div>
  );
};
export default ShowTable;
